export type Dictionary = Record<string, string>
export type TranslateVars = Record<string, string | number>
export type Translator = (key: string, vars?: TranslateVars) => string

/**
 * 사전 하나로 문구를 만든다.
 *
 * 모르는 키는 키 자체를 돌려준다 — 화면이 빈칸이 되면 무엇이 빠졌는지 알 수 없다.
 * 값을 주지 않은 치환 변수도 `{name}` 그대로 남겨 눈에 띄게 둔다.
 */
export function createTranslator(dictionary: Dictionary): Translator {
  return (key, vars) => {
    const template = dictionary[key]
    if (template === undefined) {
      if (typeof console !== "undefined") console.warn(`[i18n] 없는 키: ${key}`)
      return key
    }
    if (!vars) return template
    return template.replace(/\{(\w+)\}/g, (whole, name: string) =>
      name in vars ? String(vars[name]) : whole,
    )
  }
}
